import img1 from "../../asset/Group 1000003780.png";
import img2 from "../../asset/Group 1000003781.png";
import img3 from "../../asset/Group 1000003782.png";

export default function AboutUs3() {
  return (
    <div className="min-h-screen bg-[#0A476C] text-white px-4 py-6 sm:py-8 md:px-8 lg:px-16">
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 
            className="mb-4 sm:mb-6 font-bold leading-tight text-white"
            style={{
              fontFamily: '"Futura Bold", Sans-serif',
              fontSize: 'clamp(40px, 8vw, 100px)',
              lineHeight: 'clamp(40px, 8vw, 100px)'
            }}
          >
            How We Can Help
          </h1>
          <p 
            className="leading-relaxed max-w-3xl mx-auto text-white"
            style={{
              fontFamily: '"Avenir Book", sans-serif',
              fontSize: 'clamp(16px, 4vw, 21px)',
              lineHeight: 'clamp(24px, 5vw, 35px)',
            }}
          >
            We partner with attorneys and law firms to provide a predictable flow of qualified accident leads. 
            Whether you are a solo attorney or a large practice, our proven systems keep your intake pipeline 
            full so you can focus on winning cases.
          </p>
        </div>

        {/* Services Section */}
        <div className="space-y-8 sm:space-y-12">

          {/* Generate Exclusive Leads */}
          <div className="flex flex-col md:flex-row items-start gap-4 sm:gap-6">
            <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full">
              <img src={img2} alt="Exclusive Leads" className="w-full h-full object-contain" />
            </div>
            <div className="flex-1">
              <h2 className="mb-3 sm:mb-4 font-bold leading-tight text-[#F58A26]"
                  style={{
                    fontFamily: '"Futura Bold", Sans-serif',
                    fontSize: 'clamp(20px, 5vw, 25px)',
                    lineHeight: 'clamp(20px, 5vw, 25px)'
                  }}
              >
                Generate Exclusive Leads
              </h2>
              <p className="mb-3 sm:mb-4 leading-relaxed text-white"
                 style={{
                   fontFamily: '"Avenir Book", sans-serif',
                   fontSize: 'clamp(16px, 4vw, 21px)',
                   lineHeight: 'clamp(24px, 5vw, 35px)'
                 }}
              >
                We deliver accident leads that are never shared with competing firms. Every lead is carefully 
                filtered and sent directly to your team, giving you the best chance to convert prospects into signed clients.
              </p>
            </div>
          </div>

          {/* Build Compliance & Trust */}
          <div className="flex flex-col md:flex-row items-start gap-4 sm:gap-6">
            <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full">
              <img src={img1} alt="Compliance & Trust" className="w-full h-full object-contain" />
            </div>
            <div className="flex-1">
              <h2 className="mb-3 sm:mb-4 font-bold leading-tight text-[#F58A26]"
                  style={{
                    fontFamily: '"Futura Bold", Sans-serif',
                    fontSize: 'clamp(20px, 5vw, 25px)',
                    lineHeight: 'clamp(20px, 5vw, 25px)'
                  }}
              >
                Build Compliance & Trust
              </h2>
              <p className="mb-3 sm:mb-4 leading-relaxed text-white"
                 style={{
                   fontFamily: '"Avenir Book", sans-serif',
                   fontSize: 'clamp(16px, 4vw, 21px)',
                   lineHeight: 'clamp(24px, 5vw, 35px)'
                 }}
              >
                We create campaigns that align with state bar advertising rules and ethical marketing standards. 
                With us, your firm’s reputation is always protected.
              </p>
            </div>
          </div>

          {/* Drive Measurable Growth */}
          <div className="flex flex-col md:flex-row items-start gap-4 sm:gap-6">
            <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full">
              <img src={img3} alt="Drive Growth" className="w-full h-full object-contain" />
            </div>
            <div className="flex-1">
              <h2 className="mb-3 sm:mb-4 font-bold leading-tight text-[#F58A26]"
                  style={{
                    fontFamily: '"Futura Bold", Sans-serif',
                    fontSize: 'clamp(20px, 5vw, 25px)',
                    lineHeight: 'clamp(20px, 5vw, 25px)'
                  }}
              >
                Drive Measurable Growth
              </h2>
              <p className="mb-3 sm:mb-4 leading-relaxed text-white"
                 style={{
                   fontFamily: '"Avenir Book", sans-serif',
                   fontSize: 'clamp(16px, 4vw, 21px)',
                   lineHeight: 'clamp(24px, 5vw, 35px)'
                 }}
              >
                Our SEO, ads, and funnel systems are designed for ROI. You’ll always see how your investment 
                translates into real cases and firm growth.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
